import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { WebAccessControlSchedulerController } from '../controller/WebAccessControlSchedulerController';

export class WebAccessControlSchedulerComponent extends BaseWebComponentElement {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: WebAccessControlSchedulerController,
    });
  }

  static override get observedAttributes(): string[] {
    return [...BaseWebComponentElement.observedAttributes, "data-company-id"];
  }

  override attributeChangedCallback(name: string, oldValue: string, newValue: string): void {
    if (WebAccessControlSchedulerComponent.observedAttributes.indexOf(name) !== -1) {
      (this.controller as WebAccessControlSchedulerController)?.render().then().catch();
    }
  }

}
